import React from "react";

export default function HostSuccess({ onClose }) {

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-xl shadow-xl w-[90%] max-w-md p-6 text-center animate-scaleIn">
        {/* Icon */}
        <div className="mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-full bg-green-100">
          <svg
            className="w-8 h-8 text-green-600"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        {/* Message */}
        <h2 className="text-lg font-semibold text-gray-800 mb-2">
          Verification Successful
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Your request for host has been verified successfully.
          <br />
          Please login again to benefit host services.
        </p>

        {/* Button */}
        <button
          onClick={onClose}
          className="w-full bg-green-600 text-white py-2 rounded-lg font-medium hover:bg-green-700 transition"
        >
          OK
        </button>
      </div>
    </div>
  );
}